export default [
    {
        path: '/product',
        name: '购买教程',
        component: r => require.ensure([], () => r(require('@/views/product/index')), 'user')
    },
    {
        path: '/product/details',
        name: '教程详情',
        component: r => require.ensure([], () => r(require('@/views/product/details')), 'user')
    },
    {
        path: '/product/buy',
        name: '确认订单',
        component: r => require.ensure([], () => r(require('@/views/product/buy')), 'user')
    },
    {
        path: '/product/address',
        name: '收货地址',
        component: r => require.ensure([], () => r(require('@/views/product/address')), 'user')
    },


]


// WEBPACK FOOTER //
// ./src/router/routers/product.js